import * as z from 'zod';
import { ShopifyCart } from 'types';
import { formatZodError } from 'utils/zod-error';
import { fetchSymbol } from '../fetch/fetch-helper';

const endpoint = '/cart/change.js';

const ProductUpdateParamsByID = z.object({
  id: z.union([z.string(), z.number()]),
  quantity: z.number().optional(),
  properties: z.record(z.string()).optional(),
  line: z.undefined()
});

const ProductUpdateParamsByLine = z.object({
  line: z.number(),
  quantity: z.number().optional(),
  properties: z.record(z.string()).optional(),
  id: z.undefined()
});

const ProductUpdateSellingPlan = z.object({
  line: z.number(),
  quantity: z.number().optional(),
  properties: z.record(z.string()).optional(),
  selling_plan: z.union([z.number(), z.null()])
});

const CartChangeParamsSchema = z.union([ProductUpdateParamsByID, ProductUpdateParamsByLine, ProductUpdateSellingPlan]);

type CartChangeParams = z.infer<typeof CartChangeParamsSchema>;

export async function change(params: CartChangeParams, noIntercept?: boolean): Promise<ShopifyCart> {
  const parseResult = CartChangeParamsSchema.safeParse(params);
  if (!parseResult.success) throw new TypeError(`Couldn't change cart due to invalid params: ${formatZodError(parseResult.error)}`);
  const res = await window[fetchSymbol].postJSON<ShopifyCart>(endpoint, params, noIntercept);
  return res;
}
